export default __webpack_public_path__ + "static/0173-b58c489105f78e32030ddc46a27f0e78.png";